export const CreditCardRefreshIcon = ({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      d="M14.6666 6.66667H1.33325M7.33325 12.6667L12.5333 12.6667C13.28 12.6667 13.6534 12.6667 13.9386 12.5213C14.1895 12.3935 14.3934 12.1895 14.5213 11.9387C14.6666 11.6534 14.6666 11.2801 14.6666 10.5333V5.46667C14.6666 4.71993 14.6666 4.34656 14.5213 4.06135C14.3934 3.81046 14.1895 3.60649 13.9386 3.47866C13.6534 3.33333 13.28 3.33333 12.5333 3.33333H11.3333M7.33325 12.6667L8.66659 14M7.33325 12.6667L8.66659 11.3333M4.66659 12.6667H3.46659C2.71985 12.6667 2.34648 12.6667 2.06126 12.5213C1.81038 12.3935 1.60641 12.1895 1.47858 11.9387C1.33325 11.6534 1.33325 11.2801 1.33325 10.5333V5.46667C1.33325 4.71993 1.33325 4.34656 1.47858 4.06135C1.60641 3.81046 1.81038 3.60649 2.06126 3.47866C2.34648 3.33333 2.71985 3.33333 3.46659 3.33333H8.66659M8.66659 3.33333L7.33325 4.66667M8.66659 3.33333L7.33325 2"
      stroke="black"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
  </svg>
);
